import instance from './http'
import api from "./config"

/**
 *  http 请求
 * */




export const   login = params => {
    return new Promise((resolve, reject) => {
        instance.post(api.api+'/auth/login', params)
            .then(response => {
                if (response){
                    resolve(response.data)
                }else {
                    resolve({})
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}

//
export const   MUserInfo = params => {
    return new Promise((resolve, reject) => {
        instance.get(api.api+'/sys/user/info', {params:params})
            .then(response => {
                if (response){
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}


//
export const   dataV = params => {
    return new Promise((resolve, reject) => {
        instance.get(api.api+'/area/datav', {params:params})
            .then(response => {
                if (response){
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}

export const   dataVJson = params => {
    return new Promise((resolve, reject) => {
        instance.get(api.api+'/area/json', {params:params})
            .then(response => {
                if (response){
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}

export const   bubbleArea = params => {
    return new Promise((resolve, reject) => {
        instance.get(api.api+'/bubble/areadata', {params:params})
            .then(response => {
                if (response){
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}

// 新增冒泡站点接口 20250828

export const   bubbleStationDataRange = params => {
    return new Promise((resolve, reject) => {
        instance.get(api.api+'/bubble/stationDataRange', {params:params})
            .then(response => {
                if (response){
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}


export const   bubbleAirstationdatarange = params => {
    return new Promise((resolve, reject) => {
        instance.get(api.api+'/bubble/airstationdatarange', {params:params})
            .then(response => {
                if (response){
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}


export const   bubbleAircitydatarange = params => {
    return new Promise((resolve, reject) => {
        instance.get(api.api+'/bubble/aircitydatarange', {params:params})
            .then(response => {
                if (response){
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}


export const   bubbleCityDataRange = params => {
    return new Promise((resolve, reject) => {
        instance.get(api.api+'/bubble/cityDataRange', {params:params})
            .then(response => {
                if (response){
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}



export const   bubbleStationdata = params => {
    return new Promise((resolve, reject) => {
        instance.get(api.api+'/bubble/stationdata', {params:params})
            .then(response => {
                if (response){
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}


export const   firepotList = params => {
    return new Promise((resolve, reject) => {
        instance.get(api.api+'/firepot/list', {params:params})
            .then(response => {
                if (response){
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}

export const   bubbleInfo = params => {
    return new Promise((resolve, reject) => {
        instance.get(api.api+'/bubble/info', {params:params})
            .then(response => {
                if (response){
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}

export const   firepotGeocode = params => {
    return new Promise((resolve, reject) => {
        instance.get(api.api+'/firepot/geocode', {params:params})
            .then(response => {
                if (response){
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}


export const   blackGasList = params => {
    return new Promise((resolve, reject) => {
        instance.get(api.api+'/blackGas/list', {params:params})
            .then(response => {
                if (response){
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}

export const   firespotList = params => {
    return new Promise((resolve, reject) => {
        instance.get(api.api+'/firespot/list', {params:params})
            .then(response => {
                if (response){
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}

export const   bubbleStationinfo = params => {
    return new Promise((resolve, reject) => {
        instance.get(api.api+'/bubble/stationinfo', {params:params})
            .then(response => {
                if (response){
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}



//  角色相关
export const   roleList = params => {
    return new Promise((resolve, reject) => {
        instance.get(api.api+'/sys/role/list', {params:params})
            .then(response => {
                if (response){
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}


export const   menuNav = params => {
    return new Promise((resolve, reject) => {
        instance.get(api.api+'/sys/menu/nav', {params:params})
            .then(response => {
                if (response){
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}

export const   menuTree = params => {
    return new Promise((resolve, reject) => {
        instance.get(api.api+'/sys/menu/tree', {params:params})
            .then(response => {
                if (response){
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}

export const   roleAdd = params => {
    return new Promise((resolve, reject) => {
        instance.post(api.api+'/sys/role/add', params)
            .then(response => {
                if (response){
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}

export const   roleEdit = params => {
    return new Promise((resolve, reject) => {
        instance.post(api.api+'/sys/role/edit', params)
            .then(response => {
                if (response){
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}

export const   roleDelete = params => {
    return new Promise((resolve, reject) => {
        instance.post(api.api+'/sys/role/delete', params)
            .then(response => {
                if (response){
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}

export const   roleInfo = roleId => {
    return new Promise((resolve, reject) => {
        instance.get(api.api+'/sys/role/info/'+roleId)
            .then(response => {
                if (response){
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}

export const   roleUlist = params => {
    return new Promise((resolve, reject) => {
        instance.get(api.api+'/sys/role/ulist',{params:params})
            .then(response => {
                if (response){
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}


//  用户相关

export const   userList = params => {
    return new Promise((resolve, reject) => {
        instance.get(api.api+'/sys/user/list',{params:params})
            .then(response => {
                if (response){
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}


export const   userAdd = params => {
    return new Promise((resolve, reject) => {
        instance.post(api.api+'/sys/user/add', params)
            .then(response => {
                if (response){
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}

export const   userEdit = params => {
    return new Promise((resolve, reject) => {
        instance.post(api.api+'/sys/user/edit', params)
            .then(response => {
                if (response){
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}

export const   userDelete = params => {
    return new Promise((resolve, reject) => {
        instance.post(api.api+'/sys/user/delete', params)
            .then(response => {
                if (response){
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}

export const   userRestpwd = params => {
    return new Promise((resolve, reject) => {
        instance.post(api.api+'/sys/user/restpwd', params)
            .then(response => {
                if (response){
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}

export const   userInfo = roleId => {
    return new Promise((resolve, reject) => {
        instance.get(api.api+'/sys/user/info/'+roleId)
            .then(response => {
                if (response){
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}




//  登录日志
export const   logLogin = params => {
    return new Promise((resolve, reject) => {
        instance.get(api.api+'/sys/log/login',{params:params})
            .then(response => {
                if (response){
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}

//  操作日志
export const   logOperate = params => {
    return new Promise((resolve, reject) => {
        instance.get(api.api+'/sys/log/operate',{params:params})
            .then(response => {
                if (response){
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}


/**
*
 *
 *
 * 字典
* */


export const   dicttypePage = params => {
    return new Promise((resolve, reject) => {
        instance.get(api.api+'/sys/dicttype/page',{params:params})
            .then(response => {
                if (response){
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}

export const   dicttypeAdd = params => {
    return new Promise((resolve, reject) => {
        instance.post(api.api+'/sys/dicttype/add', params)
            .then(response => {
                if (response){
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}


export const   dicttypeEdit = params => {
    return new Promise((resolve, reject) => {
        instance.post(api.api+'/sys/dicttype/edit', params)
            .then(response => {
                if (response){
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}

export const  dicttypeInfo = roleId => {
    return new Promise((resolve, reject) => {
        instance.get(api.api+'/sys/dicttype/info/'+roleId)
            .then(response => {
                if (response){
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}
export const  dicttypeDelete = params => {
    return new Promise((resolve, reject) => {
        instance.post(api.api+'/sys/dicttype/delete', params)
            .then(response => {
                if (response){
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}

export const   dictdataPage = params => {
    return new Promise((resolve, reject) => {
        instance.get(api.api+'/sys/dictdata/page',{params:params})
            .then(response => {
                if (response){
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}

export const  dictdataAdd = params => {
    return new Promise((resolve, reject) => {
        instance.post(api.api+'/sys/dictdata/add', params)
            .then(response => {
                if (response){
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}

export const  dictdataEdit = params => {
    return new Promise((resolve, reject) => {
        instance.post(api.api+'/sys/dictdata/edit', params)
            .then(response => {
                if (response){
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}

export const  dictdataDelete = params => {
    return new Promise((resolve, reject) => {
        instance.post(api.api+'/sys/dictdata/delete', params)
            .then(response => {
                if (response){
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}

/**
 *
 *
 * 消息
 *
 */

export const   noticePage = params => {
    return new Promise((resolve, reject) => {
        instance.get(api.api+'/notice/page',{params:params})
            .then(response => {
                if (response){
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}

export const   noticeInfo = id => {
    return new Promise((resolve, reject) => {
        instance.get(api.api+'/notice/info/'+id,)
            .then(response => {
                if (response){
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}


export const   noticetypePage = params => {
    return new Promise((resolve, reject) => {
        instance.get(api.api+'/sys/noticetype/page',{params:params})
            .then(response => {
                if (response){
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}

export const  noticetypeInfo = roleId => {
    return new Promise((resolve, reject) => {
        instance.get(api.api+'/sys/noticetype/info/'+roleId)
            .then(response => {
                if (response){
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}

export const  noticetypeAdd = params => {
    return new Promise((resolve, reject) => {
        instance.post(api.api+'/sys/noticetype/add', params)
            .then(response => {
                if (response){
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}

export const  noticetypeEdit = params => {
    return new Promise((resolve, reject) => {
        instance.post(api.api+'/sys/noticetype/edit', params)
            .then(response => {
                if (response){
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}

export const  noticetypeDelete = params => {
    return new Promise((resolve, reject) => {
        instance.post(api.api+'/sys/noticetype/delete', params)
            .then(response => {
                if (response){
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}




export const   noticedataPage = params => {
    return new Promise((resolve, reject) => {
        instance.get(api.api+'/sys/noticedata/page',{params:params})
            .then(response => {
                if (response){
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}


export const  noticetypeList = params => {
    return new Promise((resolve, reject) => {
        instance.get(api.api+'/sys/noticetype/list',{params:params})
            .then(response => {
                if (response){
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}

export const  noticedataInfo = roleId => {
    return new Promise((resolve, reject) => {
        instance.get(api.api+'/sys/noticedata/info/'+roleId)
            .then(response => {
                if (response){
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}

export const noticedataAdd = params => {
    return new Promise((resolve, reject) => {
        instance.post(api.api+'/sys/noticedata/add', params)
            .then(response => {
                if (response){
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}

export const  noticedataEdit = params => {
    return new Promise((resolve, reject) => {
        instance.post(api.api+'/sys/noticedata/edit', params)
            .then(response => {
                if (response){
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}

export const noticedataDelete = params => {
    return new Promise((resolve, reject) => {
        instance.post(api.api+'/sys/noticedata/delete', params)
            .then(response => {
                if (response){
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}



/**
 *
 * 宿州工业源
 *
 * */



export const departmentPage = params => {
    return new Promise((resolve, reject) => {
        instance.get(api.api+'/department/page',{params:params})
            .then(response => {
                if (response){
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}

export const departmentList = params => {
    return new Promise((resolve, reject) => {
        instance.get(api.api+'/department/list',{params:params})
            .then(response => {
                if (response){
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}

export const  departmentInfo = roleId => {
    return new Promise((resolve, reject) => {
        instance.get(api.api+'/department/info/'+roleId)
            .then(response => {
                if (response){
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}


export const  areaTree = params => {
    return new Promise((resolve, reject) => {
        instance.get(api.api+'/area/tree',{params:params})
            .then(response => {
                if (response){
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}


export const  departmentCount = params => {
    return new Promise((resolve, reject) => {
        instance.get(api.api+'/department/count',{params:params})
            .then(response => {
                if (response){
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}

/**
 *
 * 排污数据
 *
 * */


export const  departmentType = params => {
    return new Promise((resolve, reject) => {
        instance.get(api.api+'/department/type',{params:params})
            .then(response => {
                if (response){
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}



export const  emissionList = params => {
    return new Promise((resolve, reject) => {
        instance.get(api.api+'/emission/list',{params:params})
            .then(response => {
                if (response){
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}


export const  tableDataHeader = params => {
    return new Promise((resolve, reject) => {
        instance.get(api.api+'/header/list',{params:params})
            .then(response => {
                if (response){
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}

export const  tableDataPage = params => {
    return new Promise((resolve, reject) => {
        instance.get(api.api+'/data/page',{params:params})
            .then(response => {
                if (response){
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}

export const  tableDataList = params => {
    return new Promise((resolve, reject) => {
        instance.get(api.api+'/data/list',{params:params})
            .then(response => {
                if (response){
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}


/**
 *
 * 减排清单
 *
 * */

export const  jpcsadgdyPage = params => {
    return new Promise((resolve, reject) => {
        instance.get(api.api+'/emission/jpcsadgdy/page',{params:params})
            .then(response => {
                if (response){
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}


export const   jpcsadgdyExportTotal = params => {
    return new Promise((resolve, reject) => {
        instance.get(api.api+'/emission/jpcsadgdy/export/total', {params:params})
            .then(response => {
                if (response){
                    resolve(response.data)
                }else {
                    resolve({})
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}


export const   jpcsadgdyExcelPage = params => {
    return new Promise((resolve, reject) => {
        instance.get(api.api+'/emission/excel/page', {params:params})
            .then(response => {
                if (response){
                    resolve(response.data)
                }else {
                    resolve({})
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}





// 减排清单排污列表
export const  jpcsadgdyGisList = params => {
    return new Promise((resolve, reject) => {
        instance.get(api.api+'/emission/jpcsadgdy/gis/list',{params:params})
            .then(response => {
                if (response){
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}


export const  jpcsadgdyGisInfo = gdyId => {
    return new Promise((resolve, reject) => {
        instance.get(api.api+'/emission/jpcsadgdy/gis/info/'+gdyId,{params:{}})
            .then(response => {
                if (response){
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}








export const  regionTree = params => {
    return new Promise((resolve, reject) => {
        instance.get(api.api+'/sys/region/tree',{params:params})
            .then(response => {
                if (response){
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}

export const jdpcodregionTree = params => {
    return new Promise((resolve, reject) => {
        instance.get(api.api+'/emission/jdpcodregion/tree',{params:params})
            .then(response => {
                if (response){
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}



export const  industryTree = params => {
    return new Promise((resolve, reject) => {
        instance.get(api.api+'/emission/industry/tree',{params:params})
            .then(response => {
                if (response){
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}



export const  anaysisPage = params => {
    return new Promise((resolve, reject) => {
        instance.get(api.api+'/anaysis/page',{params:params})
            .then(response => {
                if (response){
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}

export const  emissionAnaysisPage = params => {
    return new Promise((resolve, reject) => {
        instance.get(api.api+'/emission/anaysis/page',{params:params})
            .then(response => {
                if (response){
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}


// /anaysis/run

export const anaysisRun = params => {
    return new Promise((resolve, reject) => {
        instance.post(api.api+'/anaysis/run', params)
            .then(response => {
                if (response){
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}

export const emissionAnaysisRun = params => {
    return new Promise((resolve, reject) => {
        instance.post(api.api+'/emission/anaysis/run', params)
            .then(response => {
                if (response){
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}

export const anaysisPagejob = params => {
    return new Promise((resolve, reject) => {
        instance.get(api.api+'/anaysis/pagejob', {params:params})
            .then(response => {
                if (response){
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}

export const emissionAnaysisPagejob = params => {
    return new Promise((resolve, reject) => {
        instance.get(api.api+'/emission/anaysis/pagejob', {params:params})
            .then(response => {
                if (response){
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}


export const  anaysisInfo = id => {
    return new Promise((resolve, reject) => {
        instance.get(api.api+'/anaysis/info/'+id,)
            .then(response => {
                if (response){
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}

export const  emissionAnaysisInfo = id => {
    return new Promise((resolve, reject) => {
        instance.get(api.api+'/emission/anaysis/info/'+id,)
            .then(response => {
                if (response){
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}


export const anaysisPausejob = params => {
    return new Promise((resolve, reject) => {
        instance.post(api.api+'/anaysis/pausejob', params)
            .then(response => {
                if (response){
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}

export const emissionAnaysisPausejob = params => {
    return new Promise((resolve, reject) => {
        instance.post(api.api+'/emission/anaysis/pausejob', params)
            .then(response => {
                if (response){
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}


export const anaysisResumejob = params => {
    return new Promise((resolve, reject) => {
        instance.post(api.api+'/anaysis/resumejob', params)
            .then(response => {
                if (response){
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}

export const emissionAnaysisResumejob = params => {
    return new Promise((resolve, reject) => {
        instance.post(api.api+'/emission/anaysis/resumejob', params)
            .then(response => {
                if (response){
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}



export const anaysisSavejob = params => {
    return new Promise((resolve, reject) => {
        instance.post(api.api+'/anaysis/savejob', params)
            .then(response => {
                if (response){
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}

export const emissionAnaysisSavejob = params => {
    return new Promise((resolve, reject) => {
        instance.post(api.api+'/emission/anaysis/savejob', params)
            .then(response => {
                if (response){
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}

export const anaysisUpdatejob = params => {
    return new Promise((resolve, reject) => {
        instance.post(api.api+'/anaysis/updatejob', params)
            .then(response => {
                if (response){
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}


export const emissionAnaysisUpdatejob = params => {
    return new Promise((resolve, reject) => {
        instance.post(api.api+'/emission/anaysis/updatejob', params)
            .then(response => {
                if (response){
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}




export const emissionAnaysisPagerecord = params => {
    return new Promise((resolve, reject) => {
        instance.get(api.api+'/emission/anaysis/pagerecord', {params:params})
            .then(response => {
                if (response){
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}











export const jpcsadgdyOverallType = params => {
    return new Promise((resolve, reject) => {
        instance.get(api.api+'/emission/jpcsadgdy/p/overall/type', {params: params})
            .then(response => {
                resolve(response.data)
            })
            .catch(error => {
                reject(error)
            })
    })
}


export const jpcsadgdyOverallSub = params => {
    return new Promise((resolve, reject) => {
        instance.get(api.api+'/emission/jpcsadgdy/p/overall/sub', {params: params})
            .then(response => {
                resolve(response.data)
            })
            .catch(error => {
                reject(error)
            })
    })
}

export const jpcsadgdyVocsType = params => {
    return new Promise((resolve, reject) => {
        instance.get(api.api+'/emission/jpcsadgdy/p/vocs/type', {params: params})
            .then(response => {
                resolve(response.data)
            })
            .catch(error => {
                reject(error)
            })
    })
}


export const jpcsadgdyCOverallSub = params => {
    return new Promise((resolve, reject) => {
        instance.get(api.api+'/emission/jpcsadgdy/c/overall/sub', {params: params})
            .then(response => {
                resolve(response.data)
            })
            .catch(error => {
                reject(error)
            })
    })
}
export const jpcsadgdyCVocsType = params => {
    return new Promise((resolve, reject) => {
        instance.get(api.api+'/emission/jpcsadgdy/c/vocs/type', {params: params})
            .then(response => {
                resolve(response.data)
            })
            .catch(error => {
                reject(error)
            })
    })
}



export const checkToken = params => {
    return new Promise((resolve, reject) => {
        instance.get(api.api+'/sso/auth/login', {params: params})
            .then(response => {
                resolve(response.data)
            })
            .catch(error => {
                reject(error)
            })
    })
}

export const publicJump = params => {
    return new Promise((resolve, reject) => {
        instance.get(api.api+'/public/jump', {params: params})
            .then(response => {
                resolve(response.data)
            })
            .catch(error => {
                reject(error)
            })
    })
}



export const aggHighValueArea = params => {
    return new Promise((resolve, reject) => {
        instance.get(api.api+'/agg/highValueArea', {params: params})
            .then(response => {
                resolve(response.data)
            })
            .catch(error => {
                reject(error)
            })
    })
}



export const firespotGroupCountByType = params => {
    return new Promise((resolve, reject) => {
        instance.get(api.api+'/firespot/groupCountByType', {params: params})
            .then(response => {
                resolve(response.data)
            })
            .catch(error => {
                reject(error)
            })
    })
}

export const firespotGroupByTypeYtoY = params => {
    return new Promise((resolve, reject) => {
        instance.get(api.api+'/firespot/groupByTypeYtoY', {params: params})
            .then(response => {
                resolve(response.data)
            })
            .catch(error => {
                reject(error)
            })
    })
}

export const firespotGroupCountByCounty = params => {
    return new Promise((resolve, reject) => {
        instance.get(api.api+'/firespot/groupCountByCounty', {params: params})
            .then(response => {
                resolve(response.data)
            })
            .catch(error => {
                reject(error)
            })
    })
}




export const  licensePage = params => {
    return new Promise((resolve, reject) => {
        instance.get(api.api+'/license/page',{params:params})
            .then(response => {
                if (response){
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}


export const  onlieDataPage = params => {
    return new Promise((resolve, reject) => {
        instance.get(api.api+'/onlieData/page',{params:params})
            .then(response => {
                if (response){
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}


export const  excessivePage = params => {
    return new Promise((resolve, reject) => {
        instance.get(api.api+'/excessive/page',{params:params})
            .then(response => {
                if (response){
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}


export const  sampleLibraryPage = params => {
    return new Promise((resolve, reject) => {
        instance.get(api.api+'/sampleLibrary/page',{params:params})
            .then(response => {
                if (response){
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}

export const  sampleLibraryInfo = params => {
    return new Promise((resolve, reject) => {
        instance.get(api.api+'/sampleLibrary/info',{params:params})
            .then(response => {
                if (response){
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}

export const  sampleLibraryExpert = params => {
    return new Promise((resolve, reject) => {
        instance.post(api.api+'/sampleLibrary/expert',params)
            .then(response => {
                if (response){
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}


export const  remoteUnPage = params => {
    return new Promise((resolve, reject) => {
        instance.get(api.api+'/remoteUn/page',{params:params})
            .then(response => {
                if (response){
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}

export const  remoteUninfo = params => {
    return new Promise((resolve, reject) => {
        instance.get(api.api+'/remoteUn/info',{params:params})
            .then(response => {
                if (response){
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}

// 查询车辆排放阶段
export const vehicleEmissionStageQuery = params => {
    return new Promise((resolve, reject) => {
        instance.get(api.api+'/vehicle/emission/stage/query', {params:params})
            .then(response => {
                if (response){
                    resolve(response.data)
                }else {
                    resolve({})
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}

export const vehicleArchiveList = params => {
    return new Promise((resolve, reject) => {
        instance.get(api.api+'/vehicle/archive/list', {params:params})
            .then(response => {
                if (response){
                    resolve(response.data)
                }else {
                    resolve({})
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}

export const vehicleArchiveView = params => {
    return new Promise((resolve, reject) => {
        instance.get(api.api+'/vehicle/archive/view', {params:params})
            .then(response => {
                if (response){
                    resolve(response.data)
                }else {
                    resolve({})
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}

export const vehicleInspectionList = params => {
    return new Promise((resolve, reject) => {
        instance.get(api.api+'/vehicle/archive/inspection/list', {params:params})
            .then(response => {
                if (response){
                    resolve(response.data)
                }else {
                    resolve({})
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}

export const vehicleInspectionView = params => {
    return new Promise((resolve, reject) => {
        instance.get(api.api+'/vehicle/archive/inspection/view', {params:params})
            .then(response => {
                if (response){
                    resolve(response.data)
                }else {
                    resolve({})
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}

export const vehicleRemoteList = params => {
    return new Promise((resolve, reject) => {
        instance.get(api.api+'/vehicle/archive/remote/list', {params:params})
            .then(response => {
                if (response){
                    resolve(response.data)
                }else {
                    resolve({})
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}

export const vehicleRemoteView = params => {
    return new Promise((resolve, reject) => {
        instance.get(api.api+'/vehicle/archive/remote/view', {params:params})
            .then(response => {
                if (response){
                    resolve(response.data)
                }else {
                    resolve({})
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}

export const vehicleExceedList = params => {
    return new Promise((resolve, reject) => {
        instance.get(api.api+'/vehicle/archive/exceed/list', {params:params})
            .then(response => {
                if (response){
                    resolve(response.data)
                }else {
                    resolve({})
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}


